// API-Konfiguration für Garden Clicker Backend

// Entwicklung vs. Produktion
const isProduction = process.env.NODE_ENV === 'production';
const isDevelopment = process.env.NODE_ENV === 'development';

// Backend-URLs
export const API_CONFIG = {
  // Primäre HTTPS-URL (Produktion)
  HTTPS_URL: 'https://vbgdn.com/api',
  
  // Fallback HTTP-URL (wenn HTTPS nicht verfügbar)
  HTTP_URL: 'http://vbgdn.com:3001/api',
  
  // Lokale Entwicklung
  LOCAL_URL: 'http://localhost:3001/api',
  
  // Aktuell verwendete URL
  get BASE_URL() {
    // Für lokale Entwicklung
    if (isDevelopment || window.location.hostname === 'localhost') {
      return this.LOCAL_URL;
    }
    
    // Für Produktion - versuche zunächst HTTPS
    return this.HTTPS_URL;
  },
  
  // Fallback-URL wenn primäre URL fehlschlägt
  get FALLBACK_URL() {
    return this.HTTP_URL;
  }
};

// Health Check mit Fallback und Timeout
const fetchWithTimeout = async (url: string, options: RequestInit = {}, timeoutMs: number = 5000): Promise<Response> => {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  
  try {
    const response = await fetch(url, {
      ...options,
      signal: controller.signal,
    });
    clearTimeout(timeoutId);
    return response;
  } catch (error) {
    clearTimeout(timeoutId);
    throw error;
  }
};

export const checkApiConnection = async (): Promise<string> => {
  try {
    // Versuche primäre URL
    const response = await fetchWithTimeout(`${API_CONFIG.BASE_URL}/health`, {
      method: 'GET',
    });
    
    if (response.ok) {
      console.log('✅ API-Verbindung erfolgreich:', API_CONFIG.BASE_URL);
      return API_CONFIG.BASE_URL;
    }
  } catch (error) {
    console.warn('⚠️ Primäre API-URL fehlgeschlagen:', error);
  }
  
  try {
    // Versuche Fallback-URL
    const response = await fetchWithTimeout(`${API_CONFIG.FALLBACK_URL}/health`, {
      method: 'GET',
    });
    
    if (response.ok) {
      console.log('✅ API-Fallback-Verbindung erfolgreich:', API_CONFIG.FALLBACK_URL);
      return API_CONFIG.FALLBACK_URL;
    }
  } catch (error) {
    console.error('❌ Alle API-URLs fehlgeschlagen:', error);
  }
  
  // Wenn alles fehlschlägt, verwende primäre URL (für Fehlermeldungen)
  return API_CONFIG.BASE_URL;
};

// Sichere API-Anfrage mit automatischem Fallback
export const apiRequest = async (endpoint: string, options: RequestInit = {}): Promise<Response> => {
  const baseUrl = await checkApiConnection();
  
  const response = await fetchWithTimeout(`${baseUrl}${endpoint}`, {
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
    },
    ...options,
  });
  
  return response;
};

export default API_CONFIG; 